import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import renderInput from '../../components/Fields/Input/Input';
import LoaderButton from '../../components/LoaderButton/LoaderButton';
import { compose } from 'redux';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const validate = (values) => {
  const errors = {};
  if (!values.otomoto_key) {
    errors.otomoto_key = 'Required';
  }
  return errors;
};

const ChannelActivationForm = (props) => {
  const submitting = false;
  const { handleSubmit, invalid, t, } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field name="login" hideMessages label="użytkownik" component={renderInput} type="text" />
      <Field name="password" hideMessages label="Hasło" component={renderInput} type="password" />
      <LoaderButton
        isLoading={submitting}
        disabled={invalid}
        label={t('activate')}
      />
    </form>
  );
};
ChannelActivationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  reduxForm({ form: 'channelActivationForm', validate, enableReinitialize: true, }),
  withScopedTranslations('ads.channels')
)(ChannelActivationForm);
